import * as constants from './../constants';
const defaultState = {
    vehicleExpenseTypes:[],
    tripExpenseTypes:[],
    currentMonth:null,
    sparkline:{},
    pnlData:{},
    vehicleExpenses:[],
    tripExpenses:[],
    officeExpenses:[],
    allVehicleExpenseTypes:[],
    allTripExpenseTypes:[],
    allOfficeExpenseTypes:[],
    journeysData:[],
    selectedJourney:{}
}
export default function expensesReducer(state = defaultState, action) {
    switch (action.type) {
        case constants.GET_EXPENSES_SPARKLINE_DATA:
            return { ...state, ...{ sparkline: action.payload } };
        case constants.GET_PNL_EXPENSES:
            return { ...state, ...{ pnlData: action.payload } };
        case constants.SELECT_JOURNEY:
            return { ...state, ...{ selectedJourney: action.payload } };
        case constants.ALL_VEHICLE_EXPENSES:
            return { ...state, ...{ allVehicleExpenseTypes: action.payload } };
        case constants.ALL_TRIP_EXPENSES:
            return { ...state, ...{ allTripExpenseTypes: action.payload } };
        case constants.ALL_OFFICE_EXPENSES_TYPES:
            return { ...state, ...{ allOfficeExpenseTypes: action.payload } };
        case constants.GET_TRUCK_EXPENSES_DATA:
            if(action.payload.merge){
                let merged =action.payload;
                merged.expenses=[
                    ...state.vehicleExpenses.expenses,
                    ...action.payload.expenses
                ]
                return { ...state, ...{ vehicleExpenses: merged} };
            }else{
                return { ...state, ...{ vehicleExpenses: action.payload } };
            }
        case constants.GET_TRIP_EXPENSES_DATA:
            if(action.payload.merge){
                let merged =action.payload;
                merged.expenses=[
                    ...state.tripExpenses.expenses,
                    ...action.payload.expenses
                ]
                return { ...state, ...{ tripExpenses: merged} };
            }else{
                return { ...state, ...{ tripExpenses: action.payload } };
            }
        case constants.GET_OFFICE_EXPENSES_DATA:
            if(action.payload.merge){
                let merged =action.payload;
                merged.expenses=[
                    ...state.officeExpenses.expenses,
                    ...action.payload.expenses
                ]
                return { ...state, ...{ officeExpenses: merged} };
            }else{
                return { ...state, ...{ officeExpenses: action.payload } };
            }
        case constants.GET_JOURNEYS:
            if(action.payload.merge){
                let merged =action.payload;
                merged.trips=[
                    ...state.journeysData.trips,
                    ...action.payload.trips
                ]
                merged.journeys=[
                    ...state.journeysData.journeys,
                    ...action.payload.journeys
                ]
                return { ...state, ...{ journeysData: merged} };
            }else{
                return { ...state, ...{ journeysData: action.payload } };
            }
        default:
            return state;
    }
}
